import React from 'react';
import * as S from './styled';

const DevelopedBy = ({ style, href }) => {

  return (
    <p style={style}>Developed by <S.DevLink href={href}>HopHop Webdesign</S.DevLink></p>
  )
};

export default DevelopedBy;